export default {
  account: {
    authentication: {
      authentication: 'Innskráning',
      login: 'Innskrá',
      username: 'Notandanafn',
      password: 'Lykilorð',
      municipality: 'Veldu bæjarfélag',
      error: {
        invalidUsername: 'Ekkert notandanafn gefið upp',
        invalidPassword: 'Ekkert lykilorð gefið upp',
      },
    },
    logout: {
      logout: 'Útskrá',
      dialog: {
        confirm: {
          title: 'Útskrá notanda',
          message: 'Ertu viss?',
          ok: 'Já',
          cancel: 'Hætta við',
        },
      },
    },
  },

  header: {
    title: 'Stjórnborð',
  },

  allocationActions: {
    receive: 'Móttekur inneign',
    transaction: 'Færir inneign',
    allocation: 'Sækir inneign',
    spending: 'Notar inneign',
    purchase: 'Kaupir inneign',
    correction: 'Leiðrétt inneign',
  },

  institution: {
    institutions: 'Stofnanir',
    name: 'Nafn',
    description: 'Lýsing',
    address: 'Heimilisfang',
    zipCode: 'Póstnúmer',
    city: 'Bæjarfélag',
    email: 'Netfang',
    website: 'Heimasíða',
    phoneNumber: 'Sími',
    googlePlaceId: 'Google Place Id',
    googlePlaceIdHint: 'Hvar finn ég place Id?',
    photoUrl: 'Hlekkur á mynd',
    dialog: {
      delete: {
        title: 'Eyða stofnun',
        message: 'Stofnun verður eytt og hún verður ekki sýnileg lengur.',
      },
    },
  },

  form: {
    submit: 'Senda',
    save: 'Vista',
    confirm: 'Staðfesta',
    forward: 'Áfram',
    close: 'Loka',
    reset: 'Endursetja',
    cancel: 'Hætta við',
    validation: {
      isRequired: 'Fylla þarf út þennan reit',
    },
  },

  errors: {
    default: {
      title: 'Villa',
      message: 'Keyrsla skilaði villu: "{error}"',
    },
    networkError: {
      title: 'Sambandsrof',
      message: 'Ekki náðist samband við þjónustur.',
    },
  },

  serviceWorker: {
    event: {
      updated: {
        title: 'Ný útgáfa af vefnum er í boði',
        message: 'Til að uppfæra vefinn þarf að endurhlaða síðuna.',
        ok: 'Endurhlaða síðuna',
        cancel: 'Ekki núna',
      },
    },
  },

  suggestions: {
    title: 'Ábendingar',
    suggestion: 'Ábendingartitill',
    addTitle: 'Bæta við titil',
    removeTitle: 'Eyða titil',
  },

  notifications: {
    title: 'Tilkynningar',
    topics: 'Flokkar',
    topic: 'Flokkur',
    create: 'Senda tilkynningu',
    parentTopic: 'Yfirflokkur',
    active: 'Virkur',
    message: 'Skilaboð',
    name: 'Titill',
    table: 'Allar tilkynningar',
    newest: 'Nýjustu tilkynningar',
    date: 'Dagsetning',
    actions: 'Aðgerðir',
    deleteDialog: {
      title: 'Eyða tilkynningu',
      message: 'Ertu viss um að þú viljir eyða þessari tilkynningu?',
      ok: 'Staðfesta',
      cancel: 'Hætta við',
    },
  },

  content: {
    title: 'Textaefni',
    headline: 'Titill',
    body: 'Innihald',
    status: {
      title: 'Staða',
    },
  },

  settings: {
    title: 'Stillingar',
    news: 'Fréttir',
    events: 'Viðburðir',
    googleApiKey: 'Google API key',
    containerLocation: 'Grenndargámar',
    email: 'Netfang sem kaup á klippum sendist á',
    airQuality: 'Veldu stöðvar sem á að birta loftgæði úr',
    submit: 'Vista',
    dialog: {
      success: {
        title: 'Aðgerð heppnaðist',
        message: 'Stillingar hafa verið vistaðar.',
        ok: 'Loka',
      },
    },
  },

  waste: {
    title: 'Gámakortið',
    search: 'Leita',
    list: {
      title: 'Hreyfingalisti',
      filter: {
        name: 'Leita eftir nafni, kt, heimilisfangi',
        dateFrom: 'Tímabil frá',
        dateTo: 'til',
        actions: 'Aðgerðir',
        all: 'Sýna allar',
        clear: 'Hreinsa síur',
      },
      table: {
        date: 'Dags - tími',
        name: 'Nafn',
        ssn: 'Kennitala',
        address: 'Heimilisfang',
        action: 'Aðgerð',
        amount: 'Magn',
        all: 'Sýna allar',
        export: 'Vista fyrir Excel',
      },
    },
    users: {
      title: 'Notendur',
      search: 'Leita eftir nafni, heimilisfangi eða kennitölu',
      credits: '{credits} klipp',
      recipient: 'Viðtakandi',
      table: {
        name: 'Nafn',
        address: 'Heimilisfang',
        zipCode: 'Póstnúmer',
        ssn: 'Kennitala',
        date: 'Dags - tími',
        action: 'Aðgerð',
        amount: 'Magn',
        empty: 'Engar færslur fundust fyrir notanda',
      },
      info: {
        client: 'Viðskiptavinur',
        realEstates: {
          title: 'Fasteignir',
          empty: 'Engar fasteignir skráðar',
        },
      },
      add: {
        title: 'Bæta korti við notanda',
        dialog: {
          title: 'Staðfesting',
          message: 'Bæta gámakorti við notandann {user}',
          ok: 'Já',
          cancel: 'Hætta við',
        },
        success: {
          title: 'Aðgerð lokið',
          message: 'Færð voru {credits} klipp af {user} yfir á {recipient}',
          ok: 'Loka',
        },
      },
      raise: {
        success: {
          title: 'Aðgerð lokið',
          message: 'Inneign var hækkuð um {credits} klipp',
        },
      },
      decrease: {
        success: {
          title: 'Aðgerð lokið',
          message: 'Inneign var lækkuð um {credits} klipp',
        },
      },
      actions: {
        title: 'Inneign',
        buyCredits: 'Skrá kaup',
        transferCredits: 'Færa inneign',
        raiseCreditLimit: 'Hækka inneign',
        raiseCreditLimitTitle: 'Skráðu það magn sem inneign á að hækka um',
        decreaseCreditLimit: 'Lækka inneign',
        decreaseCreditLimitTitle: 'Skráðu það magn sem inneign á að lækka um',
        amount: 'Magn',
        confirm: 'Gefa',
      },
    },
    operation: {
      allocation: 'Úthlutað',
      spending: 'Notað',
      transaction: 'Gefið',
      received: 'Móttekið',
    },
    realEstate: {
      title: 'Fasteignir',
      search: 'Leita eftir fastanúmeri eða heimilisfangi',
      table: {
        name: 'Fastanúmer',
        address: 'Heimilisfang',
        zipCode: 'Póstnúmer',
        ssn: 'Kennitala',
        cardType: 'Tegund',
        date: 'Dagsetning',
        operation: 'Aðgerð',
        credits: 'Magn',
        rowsPerPage: 'Fjöldi á síðu',
      },
    },
    credits: {
      title: 'Kaup á inneign',
      buyer: 'Kaupandi',
      buyerPlaceholder: 'Nafn eða kennitala',
      choose: 'Veldu notanda úr listanum',
      amount: {
        title: 'Magn keypt',
        message: 'Magn',
      },
      explanation: {
        title: 'Skýring',
        message: 'Skrá skýringu',
      },
      confirm: 'Staðfesta kaup',
      dialog: {
        title: 'Staðfesta',
        message: 'Staðfesta kaup á {buyer}',
        ok: 'Já',
        cancel: 'Hætta við',
        success: {
          title: 'Færsla heppnaðist',
          message: '{amount} klipp voru keypt',
          ok: 'Loka',
        },
        error: {
          title: 'Villa',
          message: 'Villa kom upp við staðsetningu: {{e}}',
        },
      },
    },
    admin: {
      title: 'Admin aðgerðir',
      update: 'Uppfæra',
      nationalRegister: 'Uppfæra þjóðskráð',
      realEstate: 'Uppfæra fasteignaskrá',
    },
  },

  date: {
    days: ['Sunnudagur', 'Mánudagur', 'Þriðjudagur', 'Miðvikudagur', 'Fimmtudagur', 'Föstudagur', 'Laugardagur'],
    daysShort: ['Sun', 'Mán', 'Þri', 'Mið', 'Fim', 'Fös', 'Lau'],
    months: ['Janúar', 'Febrúar', 'Mars', 'Apríl', 'Maí', 'Júní', 'Júlí', 'Ágúst', 'September', 'Október', 'Nóvember', 'Desember'],
    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maí', 'Jún', 'Júl', 'Ágú', 'Sep', 'Okt', 'Nóv', 'Des'],
  },
};
